export const isCeshi = (window.location.host.indexOf("minner.jr.jd.com") > -1 ||
  window.location.host.indexOf("localhost") > -1)

export function parseUrlSearchToObj () {
  let searchStr = decodeURIComponent(window.location.search)
  let queryArr = searchStr.slice(1).split('&')
  let result = {}
  queryArr.forEach(item => {
    let temp = item.split('=')
    if (temp[1]) {
      let key = temp[0].toString().trim()
      result[key] = temp[1].toString().trim()
    }
  })
  return result
}

export function genUrlSearchFromObj (queryObj) {
  // 对查询对象进行排序
  let {
    actCode = '',
    source = ''
  } = queryObj
  delete queryObj.actCode
  delete queryObj.source

  let searchStr = ''
  let keys = Object.keys(queryObj)

  keys.forEach(key => {
    searchStr += `${key}=${queryObj[key] || ''}&`
  })
  let str = `actCode=${actCode}&source=${source}&${searchStr.slice(0, -1)}`
  return str
}

export function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if(keys) {
    for(var i = keys.length; i--;)
    document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
  }
}



// WEBPACK FOOTER //
// ./src/public/util.js